import React from 'react';
/**
 * Created by subhash-bishnoi (https://github.com/subhash-bishnoi)
 * on 02/04/18
 */

import styles from './styles.css';

const English = () => {
  return (
    <div className={styles['tnc-wrapper']}>
      <ol className={styles['header-ol']}>
        <li>
          <b>Article 1 : Definition</b>
          <ol type="1">
            <li>
              <b>Affiliates</b> is valid controller of one of the Party,
              subsidiaries of one of the Party, or the party that in the same
              controller with one of the Party.
            </li>
            <li>
              <b>Transaction Fee</b> means the fee payable by the Merchant to
              Payment Gateway for every successful Online Transaction.
            </li>
            <li>
              <b>Business Day</b> is a day other than Saturday, Sunday and
              national public holiday which banks are operating in Indonesia for
              normal business.
            </li>
            <li>
              <b>Payment Method</b> is method of transactions which are
              available in the Online Payment System.
            </li>
            <li>
              <b>The Parties/Both Parties</b> Payment Gateway dan Merchant
              together
            </li>
            <li>
              <b>Customer</b> is a person who conducts an POS/VM Transaction in
              Merchant, through the Online Payment System
            </li>
            <li>
              <b>Point of Sales (POS)</b> s POS Vendor’s cashier machine
              application that connect with Android and/or IOS to calculate the
              Sales Transaction in Merchants’ outlets.
            </li>
            <li>
              <b>Refund</b> is the return of funds of an Online Transaction to a
              Customer in order to settle a cancellation of the said Online
              Transaction.
            </li>
            <li>
              <b>Online Payment System </b>means the payment system which
              connects Bank/Service Provider, Payment Gateway, and POS and/or
              Vending Machine, which is owned, developed, and managed by Payment
              Gateway.
            </li>
            <li>
              <b>Service Provider</b> is a payment method service provider other
              than Bank which has entered an agreement with Payment Gateway and
              is connected with Payment Gateway.
            </li>
            <li>
              <b>Online Transaction</b> is an electronic transaction which is
              done by the Customer on a Merchant’s website through the Online
              Payment System.
            </li>
            <li>
              <b>Vending Machine (VM)</b> is a tool/machine that sold goods
              automatically which can receive payment through GO-PAY.
            </li>
          </ol>
        </li>

        <li>
          <b>Article 2 : Merchant’s Registration and Requirements </b>
          <ol type="1">
            <li>
              Online Transaction shall only be conducted on the POS/VM attached
              in Merchant, with the POS Vendor/VM Operator as stated in this
              Agreement.
            </li>
            <li>
              Merchant agrees not to sell of offer the goods or services
              prohibited by law/regulations/public order and/or specifically
              prohibited by Bank, Service Provider or Service Provider.
            </li>
            <li>
              Payment Gateway has the right to refuse to provide the Services to
              the Merchant, with the following category:
              <ol type="1">
                <li>
                  Involved in any criminal organization or violates social,
                  religious, or moral norms;
                </li>
                <li>Involved in an illegal organization;</li>
                <li>
                  Include in the Payment Gateway, Service Provider, or POS’
                  Blacklist;
                </li>
                <li>
                  Another consideration determined by the Payment Gateway, POS,
                  or Service Provider.
                </li>
              </ol>
            </li>
            <li>
              In the event of Merchant changes its business model dan/or goods
              or services sold, and any change of Merchant’s shareholder,
              directors, and/or person in charge (including but not limited to
              TIN), Merchant shall inform Payment Gateway for at least 5 (five)
              Business Days after to such changes are in effect. In the event
              the Merchant does not fulfill its obligations under this Article,
              all risks will be the responsibility of the Merchant.
            </li>
          </ol>
        </li>

        <li>
          <b>Article 3 : Payment Gateway’s Rights and Obligations</b>
          <ol type="1">
            <li>
              Payment Gateway’s rights, unless otherwise stated in other clauses
              in this Agreement, are the following:
              <ol type="1">
                <li>
                  to receive Transaction Fee payments for every successful
                  Online Transaction;
                </li>
                <li>
                  Restrict, block, delete and/or terminate Online Payment System
                  and take the legal steps as necessary if Merchant suspected
                  have done violation under this agreement or other applicable
                  laws;
                </li>
                <li>
                  entitled to use the name, logo, emblem, a symbol of
                  trademarks/services of the Merchant for the purpose of
                  promotion or publicity relating to the implementation of this
                  Agreement, without transferring the Intellectual Property
                  Rights.
                </li>
              </ol>
            </li>
            <li>
              Payment Gateway’s obligations, unless otherwise stated in other
              clauses in this Agreement, are the following:
              <ol type="1">
                <li>
                  To operate and maintain the Online Payment System so that it
                  is functional and operational;
                </li>
                <li>
                  To provide Online Transaction data recapitulation for
                  Merchant;
                </li>
                <li>
                  To provide technical and operational support to Merchant if
                  needed;
                </li>
                <li>
                  to provide Standard Operating Procedure to conduct Online
                  Payment System between Merchant and Payment Gateway.
                </li>
              </ol>
            </li>
          </ol>
        </li>

        <li>
          <b>Article 4: Merchant’s Rights and Obligations</b>
          <ol type="1">
            <li>
              Merchant’s rights, unless otherwise stated in other clauses in
              this Agreement, are the following:
              <ol type="1">
                <li>
                  to receive technical and operational support from Payment
                  Gateway;
                </li>
                <li>
                  entitled to use Payment Gateway’s logo on payment page to
                  indicate that the Merchant uses Payment Gateway’s Online
                  Payment System, without transferring the Intellectual Property
                  Rights;
                </li>
                <li>
                  to receive status information of every Online Transaction; and
                </li>
                <li>
                  to receive related education and information regarding the
                  execution of Online Payment System service.
                </li>
              </ol>
            </li>
            <li>
              Merchant’s obligations, unless otherwise stated in other clauses
              in this Agreement, are the following:
              <ol type="1">
                <li>to pay the Transaction Fee to Payment Gateway;</li>
                <li>
                  deliver the goods or products that have been ordered by the
                  Customer after receiving successful notification transaction;
                </li>
                <li>
                  to keep Online Transaction receipt for at least 24
                  (twenty-four) months after the transaction date of Online
                  Transaction
                </li>
                <li>to have Refund policy; dan</li>
                <li>
                  to comply all of terms and conditions which have been set by
                  the Bank and the Service Provider.
                </li>
              </ol>
            </li>
          </ol>
        </li>

        <li>
          <b>Article 5 : Standard Operational Procedure (SOP)</b>
          <ol type="1">
            <li>
              Merchant will get the report of daily transaction from Payment
              Gateway through media that will be given by the Payment Gateway.
            </li>
            <li>
              Transaction Settlement Time All Transaction which are authorized
              by Service Provider between 00.00 until 23.59 in the same day,
              shall be settled on 15.00 the next day (H+1).
            </li>
            <li>
              Fraud Transaction Handling Payment Gateway reserves the right to
              withhold the disbursement of funds to the Merchant in the event of
              suspicion from Payment Gateway/POS/VM Operator/Service Provider on
              the existence of fraud (fraud) conducted by the Merchant. In the
              event of such suspicion, the Merchant is obliged to provide
              documents to prove that the Merchant did not commit fraud. In the
              event that Merchant fail to prove it, then the Payment Gateway
              reserves the right to Refund of all Online transactions that have
              been done and Payment Gateway can perform any legal action,
              including termination of the Agreement.
            </li>
            <li>
              Refund
              <ol type="1">
                <li>
                  The implementation and time period for Refund will be adapted
                  to Bank and Principal’ policies.
                </li>
              </ol>
            </li>
          </ol>
        </li>

        <li>
          <b>Article 6 : Transaction Fee and Payments</b>
          <ol type="1">
            <li>
              Merchant shall pay the Transaction Fee to Payment Gateway for
              every successful Online Transaction through Payment Gateway’s
              Online Payment System.
            </li>
            <li>
              Merchant will be charged the Transaction Fee as agreed, where such
              costs do not include Bank administrative costs and applicable
              taxes.
            </li>
            <li>
              The Transaction Fee payments mechanism shall be specified as
              follows:
              <ol type="1">
                <li>
                  For every successful Online Transaction, Payment Gateway shall
                  keep the Online Transaction funds in Payment Gateway’s in 1
                  (one) Business Days after the Online Transaction occurs.
                </li>
                <li>
                  After the length of period mentioned above is over, Payment
                  Gateway shall transfer the funds according to Online
                  Transaction amount after the Transaction Fee deducted to
                  Merchant’s Bank account in the same Business Day.
                </li>
                <li>
                  The Online Transaction funds, after Transaction Fee deduction,
                  shall be transferred to Merchant’s account as stated in this
                  Agreement without the issuance of the invoice and / or
                  evidence of other billing.
                </li>
              </ol>
            </li>
          </ol>
        </li>

        <li>
          <b>Article 7 : Temporary Suspension of Online Payment System</b>
          <ol type="1">
            <li>
              Payment Gateway may suspend its Online Payment System service
              temporarily with a prior notice to Merchant at least within 5
              (five) Business Days before the service suspension starts.
            </li>
            <li>
              Suspension of the Online Payment System service may be caused due
              to the following reasons:
              <ol type="1">
                <li>Inspection, maintenance and/or upgrade;</li>
                <li>
                  Any reason in order to protect any rights and/or interest of
                  the Parties; or
                </li>
                <li>
                  Any other reason as defined by Payment Gateway, POS, VM
                  Operator or Service Provider.
                </li>
              </ol>
            </li>
            <li>
              If there is any internet connection or hardware failure or any
              other reason, Payment Gateway shall give written notice to
              Merchant of this disorders and will notify Merchant when the
              disorder has been completed.
            </li>
          </ol>
        </li>

        <li>
          <b>Article 8 : Security and Data Protection</b>
          <ol type="1">
            <li>
              Payment Gateway must have a system and network that is completely
              secure, in order to protect the following:
              <ol type="1">
                <li>
                  Online Transaction information (i.e. card number, Customer’s
                  user identification, etc.); and
                </li>
                <li>any other information deemed sensitive by both Parties.</li>
              </ol>
            </li>
            <li>
              Payment Gateway shall store and protect Online Transaction data
              for a period of 24 (twenty-four) months after the Online
              Transaction date.
            </li>
            <li>
              Merchant shall ensure that it will not do the following:
              <ol type="1">
                <li>Reverse engineer the Online Payment System;</li>
                <li>
                  any activity that deliberately tries to damage the Online
                  Payment System; or
                </li>
                <li>
                  any activity that deliberately tries to breach Online
                  Transaction and Customer information.
                </li>
              </ol>
            </li>
            <li>
              Merchant shall ensure the data security and customer information.
              In the case of Merchant violates this provision, the Payment
              Gateway reserves the right to turn off the Online Payment System
              after the Merchant success to fulfill its obligations.
            </li>
          </ol>
        </li>

        <li>
          <b>Article 9: Terms of termination of Agreement</b>
          <ol type="1">
            <li>
              The term of this Agreement commences on the effective date and its
              initial term is for 1 (one) year. Thereafter, this Agreement will
              renew automatically unless either party gives the other written
              notice at least 30 (thirty) days prior to expiry of the then
              current term that it does not intend to renew.
            </li>
            <li>
              Either Party may terminate this Agreement if:
              <ol type="1">
                <li>
                  one of the Party is in breach of a material term of this
                  Agreement, which breach is not capable of being remedied;
                </li>
                <li>
                  one of the Party is in breach of a material term of this
                  Agreement, which breach is capable of being remedied, and if
                  the default Party has not remedied the breach within 30
                  (thirty) days after the date of such breach has occur; or
                </li>
                <li>
                  one of the Party becomes insolvent, ceases to carry on
                  business as a going concern and the license permit is revoked,
                  either partially or totally, comply Article 15 of this
                  Agreement concerning to Force Majeure, and therefore is unable
                  to continue their business activity;
                </li>
              </ol>
            </li>
            <li>
              In the event of termination or expiration of this Agreement, the
              Parties agree to fulfill the remaining obligations incurred before
              and/or during the termination of this Agreement. The Parties shall
              settle all of the obligations within 7 (seven) BUSINESS DAYS after
              the termination date.
            </li>
            <li>
              In the event of this Agreement’s termination, the Parties agree to
              waive the regulations as set by clause 1266 and 1267 of Kitab
              Undang-Undang Hukum Perdata (Indonesian Civil Code).
            </li>
          </ol>
        </li>

        <li>
          <b>Article 10 : Acknowledgement</b>
          <ol type="1">
            <li>
              Each Party is a company incorporated and existing under the law of
              the Republic of Indonesia, and has the necessary legal
              requirements, permits and registrations and not being revoked the
              authority of inaction under the prevailing laws in order to
              operate its business, including but not limited to making, signing
              and execution of this Agreement and any other documents relating
              to this Agreement.
            </li>
            <li>
              Each signatory of this Agreement is the competent authority or its
              authorized representatives to bind himself or its company (whether
              a legal entity or non-legal entity); in case the signatory is not
              the competent authority or its authorized representatives, then
              the signatory will responsible personally.
            </li>
            <li>
              Each Party guarantees that the documents submitted to the other
              Party are legitimate, original, valid, prevail and any information
              stated in such documents is true, according to actual situation
              and not an invention or fraud or deceit.
            </li>
            <li>
              Each Party hereby and for the future release and hold harmless the
              other Party from any suits, demands or claims from anyone that is
              not directly related with this Agreement.
            </li>
          </ol>
        </li>

        <li>
          <b>Article 11 : Governing Law and Dispute Resolution</b>
          <ol type="1">
            <li>
              This Agreement is made under the law and regulation of the
              Republic of Indonesia.
            </li>
            <li>
              In the event of dispute between the Parties regarding this
              Agreement, the Parties shall try to their best of their ability to
              resolve such dispute in an deliberation to reach a consensus. If
              the dispute resolution as mentioned in clause 12.2 above is not
              attained, the Parties agreed to choose the legal domicile in State
              Court of South Jakarta (Pengadilan Negeri Jakarta Selatan) to
              assist the dispute resolution.
            </li>
          </ol>
        </li>

        <li>
          <b>Article 12 : Confidentiality</b>
          <ol type="1">
            <li>
              The Parties agree that all information disclosed and exchanged
              during this Agreement is confidential and The Parties with its
              affiliates shall hold the Confidential Information in strict,
              unless it is permitted in writing by the disclosing party to
              disclose such information and/or that Confidential Information is
              already public knowledge.
            </li>
            <li>
              During this Agreement and after its termination, The Parties and
              all those who work for the Parties, including its affiliates, are
              still obliged to hold the Confidential Information in any form
              regarding to Customer whether obtained from other Parties or from
              the Online Transaction through Online Payment System includes as a
              secret Bank and/or the Parties that are required and should be
              kept as confidential.
            </li>
          </ol>
        </li>

        <li>
          <b>Article 13 : (Force Majeure)</b>
          <ol type="1">
            <li>
              Event of Force majeure means an event beyond the control of either
              Party or The Parties, which prevents a Party or the Parties from
              complying with any of its obligations under this Agreement,
              including but not limited to power failure, war, hostilities,
              riot, commotion, strikes, epidemic or any government intervention
              which directly impact this Agreement.
            </li>
            <li>
              In the event of Force Majeure, affected Party shall inform the
              other Party up to 7 (seven) days since the event of Force Majeure
              occur, therefore the Parties hereby will not be responsible for
              any negligence or delay in the implementation of all or part of
              this Agreement.
            </li>
            <li>
              Consequences of the event of Force Majeure shall be resolved in an
              amicable manner between both Parties. In case the Force majeure
              continually for 30 (thirty) calendar days, then The Party may
              terminate this Agreement.
            </li>
          </ol>
        </li>

        <li>
          <b>Article 14 : Others</b>
          <ol type="1">
            <li>
              <b>Appendix.</b> All Appendix, Addendum, Communication Letter, as
              well as other documents made under or in connection with this
              Agreement, is an integral part of and become inseparable
              attachment of this Agreement.
            </li>
            <li>
              <b>Amendment.</b> This Agreement may not be amended or
              supplemented unless agreed by the Parties and set out in a formal
              agreement signed by the Parties.
            </li>
            <li>
              <b>Addendum.</b> In the event of any addition that has not been
              specified or mentioned in this Agreement, therefore may result
              modifications of this Agreement and signed by the Parties. This
              addendum will be an integral part of and become inseparable
              attachment of this Agreement.
            </li>
            <li>
              <b>Waiver.</b>In the event of failure, delay or late delivery by
              either Party in the exercise of their rights or demand the
              fulfillment of the obligation of the other Party under this
              Agreement, then such failure, delay or late delivery not
              constitute a waiver by the Party in the future to exercise their
              rights or demand the fulfillment of the obligations of the other
              Party under this Agreement.
            </li>
            <li>
              <b>Non-solicitation.</b> This agreement is binding and is made for
              the benefit of each party, the recipient and/or substitute, but
              with the provision that no Party shall transfer any rights arising
              out of or relating to this Agreement to any third party, without
              the prior written consent of the other Party.
            </li>
            <li>
              <b>Language.</b> This Agreement is executed in 2 (two) languages,
              namely Indonesian language and English language. In case there are
              any oppositions or differentials of definitions or translation,
              then the provisions in Indonesian language shall be valid.
            </li>
          </ol>
        </li>
      </ol>
    </div>
  );
};

export default English;
